import React, { MouseEvent } from 'react';
import { useThemeContext } from 'contexts';
import { ThemeNames } from 'types/themes';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const NibIcon = ({ className, onClick }: Props) => {
  const { themeName } = useThemeContext();
  const isExpTheme = themeName && themeName !== ThemeNames.ZOOCASA;

  return (
    <>
      { !isExpTheme ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 2.75 18 18" className={className} onClick={onClick}>
          <path d="M9.64683 11.3291L10 11.6815L10.3532 11.3291L13.8246 7.86517L14.2929 8.33345L10 12.6263L5.70711 8.33345L6.17539 7.86517L9.64683 11.3291Z" fill="#0C0F24" stroke="#0C0F24"/>
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 2.75 20 20" className={className} onClick={onClick}>
          <path d="M9.64683 11.3291L10 11.6815L10.3532 11.3291L13.8246 7.86517L14.2929 8.33345L10 12.6263L5.70711 8.33345L6.17539 7.86517L9.64683 11.3291Z" fill="#0C0F24" stroke="#0C0F24"/>
        </svg>
      )}
    </>
  );
};

export default NibIcon;
